// 初始化TwoCoInlineCart
let timer = 0 // 计时器
function initTwoCoInlineCart () {
  if (window.TwoCoInlineCart) {
    return window.TwoCoInlineCart
  } else {
    timer += 1000
    if (timer >= 60 * 1000) {
      return null
    } else {
      setTimeout(initTwoCoInlineCart, 1000)
    }
  }
}
initTwoCoInlineCart()

let InlineCart = {

  // 初始化配置
  initConfig () {
    // 测试环境调支付
    // window.TwoCoInlineCart.cart.setTest(true)
    // 正式环境调支付
    window.TwoCoInlineCart.cart.setTest(false)
    window.TwoCoInlineCart.cart.setLanguage('en')
  },

  /** 添加商品到购物车 */
  addProduct (code, quantity = 1, priceOptions = []) {
    window.TwoCoInlineCart.products.add({
      code: code,
      quantity: quantity,
      options: priceOptions
    })
  },
  /** 移除全部商品到购物车 */
  removeAllProduct () {
    window.TwoCoInlineCart.products.removeAll()
  },
  /** 移除一件商品到购物车 */
  removeProduct (code) {
    window.TwoCoInlineCart.products.remove({
      code: code
    })
  },

  /**
   * 购买过程中添加回调
   * openedCallback  打开购物车
   * finalizedCallback  付款完成
   *
   */
  finalizedCallback (callback) {
    window.TwoCoInlineCart.events.subscribe('payment:finalized', function (res) {
      callback(res)
    })
  },

  openedCallback (callback) {
    window.TwoCoInlineCart.events.subscribe('cart:opened', function () {
      callback()
    })
  },

  closedCallback (callback) {
    window.TwoCoInlineCart.events.subscribe('cart:closed', function () {
      callback()
    })
  },

  /**
   *
   * @param {*} request
   * request = {
   *  params: {
   *    saleSource: string  require                     //销售渠道
   *    productCode: string  require                    //商品code
   *    productQuantity: Number                         //商品数量
   *    orderId: string  require                        //订单Id
   *    customerId: Nubmer  require                     //用户Id
   *    priceOptions: [                                 //商品价格配置
   *      {
   *         name: string                               //价格分类code
   *         value: string                              //当前价格code
   *      }
   *    ]
   *  }
   *  finalized: function                               //支付完成回调
   *  opened：function                                  //打开2checkout支付窗口
   *  closed：function                                  //关闭窗口完成回调
   * }
   */
  startCheckout (request) {
    this.initConfig()
    let params = request.params
    this.addProduct(
      params.productCode,
      params.productQuantity
    )
    window.TwoCoInlineCart.cart.setSource(params.saleSource)
    window.TwoCoInlineCart.cart.setOrderExternalRef(params.orderId)
    window.TwoCoInlineCart.cart.setCustomerReference(params.customerId)
    if (request.finalized) {
      this.finalizedCallback(request.finalized)
    }
    if (request.opened) {
      this.openedCallback(request.opened)
    }
    if (request.closed) {
      this.closedCallback(request.closed)
    }
    window.TwoCoInlineCart.cart.checkout()
  }
}

export default InlineCart



// WEBPACK FOOTER //
// ./src/modules/christmasPC-2019/plugins/inlineCart.js